import scrollTo from "./scrollTo";

export default function ScrollToTop() {
	let btn = document.querySelector( '#toTop' );
	if ( btn ) {
		window.addEventListener( 'scroll', function () {
			// show if > 599px
			if ( pageYOffset > 100 ) {
				btn.classList.add( 'show' );
				// remove
			} else {
				btn.classList.remove( 'show' );
			}
		} );

		// to top on click
		btn.onclick = function ( click ) {
			click.preventDefault();
			scrollTo( 0, 400 );
		}
	}
}